<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="计划专员备注"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
        prop="projectDeptPlanRemark"
        :rules="rules.projectDeptPlanRemark"
        v-if="fieldType==='projectDeptPlanRemark'"
      >
        <a-input type="text" v-model="formData.projectDeptPlanRemark" :maxLength="100" />
      </a-form-model-item>
      <a-form-model-item
        label="事业部备注"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
        prop="businessUnitRemark"
        :rules="rules.businessUnitRemark"
        v-if="fieldType==='businessUnitRemark'"
      >
        <a-input type="text" v-model="formData.businessUnitRemark" :maxLength="100" />
      </a-form-model-item>
      <a-form-model-item
        label="计划统筹备注"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
        prop="planCoordinationRemark"
        :rules="rules.planCoordinationRemark"
        v-if="fieldType==='planCoordinationRemark'"
      >
        <a-input type="text" v-model="formData.planCoordinationRemark" :maxLength="100" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { demandPlacementBillEditBatch } from '@/api/scp/pre-order-and-placement/pre-order-and-placement'
import moment from 'moment';

export default {
  name: 'BatchEditModal',
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      formData: {
        projectDeptPlanRemark: "",
        businessUnitRemark: "",
        planCoordinationRemark: ""
      },
      loading: false,
      rules: {
        projectDeptPlanRemark: [{ required: true, message: ' ', trigger: 'blur' }],
        businessUnitRemark: [{ required: true, message: ' ', trigger: 'blur' }],
        planCoordinationRemark: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (list, field) {
      this.fieldType = field // 区分修改字段标识
      this.selectedRows = list
      this.formData.projectDeptPlanRemark = ""
      this.formData.businessUnitRemark = ""
      this.formData.planCoordinationRemark = ""
      this.modal = true
    },
    // 保存
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const params = []
          this.selectedRows.forEach(v => {
            const param = { id: v.id }
            param[this.fieldType] = this.formData[this.fieldType]
            params.push(param)
          })
          this.loading = true;
          demandPlacementBillEditBatch(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('操作成功')
              this.$emit("refreshFun")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
